import React from "react";
import { useTranslation } from 'react-i18next';  
const Contact = () => {
  return (
    <div></div>
  );
};
  
export default Contact;